import React from "react";
import moment from "moment";
import config from "./../config";
import Link from '@material-ui/core/Link';

export const generateColumns = (constants) => [
    {
        Header: 'Date',
        accessor: 'publishedAt',
        Cell: props => moment(props.value).format(config.dateFormat)
    },
    {
        Header: 'Title',
        accessor: 'title'
    },
    {
        Header: 'Link',
        accessor: 'url',
        Cell: props => <Link href={config.baseEndpoint + props.value} target="_blank" rel="noopener noreferrer">View article</Link>
    },
    ...constants.pdfDownloadsEnabled ? [{
        Header: 'PDF',
        accessor: 'pdfUrl',
        Cell: ({value}) => value ? <Link href={config.baseEndpoint + value} target="_blank" rel="noopener noreferrer">View document</Link> : <span>&ndash;</span>
    }] : [],
];
